import { IActivity } from './IActivity'
import { IActivityCategories } from './IActivityCategories'
import { IDepartment } from './IActivityState'
import { IActivityWithTreatmentCode } from './IActivityWithTreatmentCode'

export const GET_ACTIVITY_LOADING = 'GET_ACTIVITY_LOADING'
export const GET_ACTIVITY_SUCCESS = 'GET_ACTIVITY_SUCCESS'
export const GET_ACTIVITY_FAILURE = 'GET_ACTIVITY_FAILURE'

export const GET_ACTIVITY_CATEGORIES_LOADING = 'GET_ACTIVITY_CATEGORIES_LOADING'
export const GET_ACTIVITY_CATEGORIES_SUCCESS = 'GET_ACTIVITY_CATEGORIES_SUCCESS'
export const GET_ACTIVITY_CATEGORIES_FAILURE = 'GET_ACTIVITY_CATEGORIES_FAILURE'

export const GET_DEPARTMENTS_LOADING = 'GET_DEPARTMENTS_LOADING'
export const GET_DEPARTMENTS_SUCCESS = 'GET_DEPARTMENTS_SUCCESS'
export const GET_DEPARTMENTS_FAILURE = 'GET_DEPARTMENTS_FAILURE'

export const GET_ACTIVITY_WITH_TREATMENT_CODE_LOADING =
  'GET_ACTIVITY_WITH_TREATMENT_CODE_LOADING'
export const GET_ACTIVITY_WITH_TREATMENT_CODE_SUCCESS =
  'GET_ACTIVITY_WITH_TREATMENT_CODE_SUCCESS'
export const GET_ACTIVITY_WITH_TREATMENT_CODE_FAILURE =
  'GET_ACTIVITY_WITH_TREATMENT_CODE_FAILURE'

interface IGetActivitySuccess {
  type: typeof GET_ACTIVITY_SUCCESS
  payload: { activity: IActivity[] }
}

interface IGetActivityFailure {
  type: typeof GET_ACTIVITY_FAILURE
  payload: { error: string }
}

interface IGetActivityWithTreatmentCodeSuccess {
  type: typeof GET_ACTIVITY_WITH_TREATMENT_CODE_SUCCESS
  payload: { activityWithCode: IActivityWithTreatmentCode[] }
}

interface IGetActivityWithTreatmentCodeFailure {
  type: typeof GET_ACTIVITY_WITH_TREATMENT_CODE_FAILURE
  payload: { error: string }
}

interface IGetActivityLoading {
  type: typeof GET_ACTIVITY_LOADING
}

interface IGetActivityWithTreatmentCodeLoading {
  type: typeof GET_ACTIVITY_WITH_TREATMENT_CODE_LOADING
}

interface IGetActivityCategoriesSuccess {
  type: typeof GET_ACTIVITY_CATEGORIES_SUCCESS
  payload: { activityCategories: IActivityCategories[] }
}

interface IGetActivityCategoriesFailure {
  type: typeof GET_ACTIVITY_CATEGORIES_FAILURE
  payload: { error: string }
}

interface IGetActivityCategoriesLoading {
  type: typeof GET_ACTIVITY_CATEGORIES_LOADING
}

interface IGetDepartmentSuccess {
  type: typeof GET_DEPARTMENTS_SUCCESS
  payload: { departments: IDepartment[] }
}

interface IGetDepartmentFailure {
  type: typeof GET_DEPARTMENTS_FAILURE
  payload: { error: string }
}

interface IGetDepartmentLoading {
  type: typeof GET_DEPARTMENTS_LOADING
}

export type TActionTypes =
  | IGetDepartmentFailure
  | IGetDepartmentLoading
  | IGetDepartmentSuccess
  | IGetActivityCategoriesLoading
  | IGetActivityCategoriesFailure
  | IGetActivityCategoriesSuccess
  | IGetActivityWithTreatmentCodeLoading
  | IGetActivityLoading
  | IGetActivityWithTreatmentCodeFailure
  | IGetActivityWithTreatmentCodeSuccess
  | IGetActivityFailure
  | IGetActivitySuccess
